import React from "react";
const DayEntryGraph = ({ data, date }) => {
  return (
    <div className="newUiBody">
      <div className="row ">
        <h6 className="p-1 bg-dark text-white">PDD Entry for ({date})</h6>
      </div>
    </div>
  );
};
export default DayEntryGraph;
